import { Box, Button, Grid, styled, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createGameFact } from "../../../actions/gameFact.js";
import { updateMatch } from "../../../actions/matchs.js";
import GameFactIcon_Dsas from "../../../dsasComponents/GameFactIcon_Dsas.js";
import {    GAME_FACT_DROP, 
            GAME_FACT_ESSAI, 
            GAME_FACT_PENALITE, 
            GAME_FACT_REDCARD, 
            GAME_FACT_TRANSFORMATION,
            GAME_FACT_RUGBY_STOP, 
            GAME_FACT_RUGBY_STAR,

            GAME_FACT_SOCCER_BUT, 
            GAME_FACT_SOCCER_REDCARD, 
            GAME_FACT_SOCCER_STOP, 
            GAME_FACT_SOCCER_STAR,
            
            GAME_FACT_START, 
            GAME_FACT_BASKET_FREETHROW,
            GAME_FACT_BASKET_TWOPOINTS,
            GAME_FACT_BASKET_THREEPOINTS,
            GAME_FACT_HANDBALL_GOAL,
            GAME_FACT_HANDBALL_YELLOWCARD,
            GAME_FACT_HANDBALL_REDCARD,
            GAME_FACT_HANDBALL_TWOMIN_SUSPENSION} from "../gameFact/constants.js";

import gameFacts from "../gameFact/gamefacts.js"
import { useScoreResolver } from "../header/useScoreResolver.js";
import { useTimer } from "../header/useTimer.js";
import { getGameFactDetail } from "../saisierapide/utils.js";
import { getTotalTimer } from "../sports/rules.js";
import { usePeriodButton } from "./useMultiplexPeriodButton.js";
import { useButtonTimer } from "./useMultiplexButtonTimer.js";
import Select_Dsas from "../../../dsasComponents/Select_Dsas.js";
import { getPlayerList } from "../utils/feuilleMatch.js";
import { formatRoundLabel } from "../utils/helpers.js";

const LiveMultiplex = ({matchs}) => {

    
    return matchs &&
    Object.entries(matchs).map(([discipline, competitions]) => (
        discipline &&
          Object.entries(competitions).map(([competitionId, matches]) => (
            <Grid item xs={12} sx={{paddingLeft : 1}} key={competitionId}>
              {Object.entries(matches).map(([day, dayMatches]) => <>
              <Typography variant="overline" component="span" sx={{fontSize : '1.4em', fontWeight : 'bold'}}>{matches[Object.keys(matches)[0]][0].competition.name},</Typography><Typography component="span" sx={{fontSize : '1em', fontStyle : 'italic', fontWeight : 'bold'}}>{formatRoundLabel(day)}.</Typography>
                {dayMatches
                  .sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime))
                  .map((match) => (
                    <MatchInMultiplex match={match} key={match.idMatch}/>
                  ))}
                  </>)}
            </Grid>
          ))
    ))

}

const MatchInMultiplex = React.memo(({match}) => {

    const Item = styled(Box)(({ theme }) => ({
        ...theme.typography.body2,
        textAlign: 'center',
        verticalAlign: 'middle',
        height : '100%', 
        display : 'flex', 
        alignItems:'center', 
        justifyContent : 'center',
        color: theme.palette.text.secondary,
      }));

      const dispatch = useDispatch()

      const [homeScore, awayScore] = useScoreResolver(match)
      const [
        timerValue, 
        updateTimer, 
        timerId, 
        startMatch, 
        stopFirstPeriod, 
        startSecondPeriod, 
        stopSecondPeriod, 
        periodValue,
        stopSecondPeriodToNext,
        startPeriod,
        stopPeriod
    ] = useTimer(match, false)
    
      const [localTimer, setLocalTimer] = useState(match.timer)

      const [playerSelected, setPlayerSelected] = useState([{_id : 0}, {_id : 0}])

    useEffect(() => {
        setLocalTimer(timerValue)

    }, [timerValue])

    const saveGameFact = (gameFact, team, defaultDetail, player) => {
        const getDetails = getGameFactDetail(gameFact)

        if(getDetails){
            const gfDetails = getDetails(match, team, player, defaultDetail)
            dispatch(createGameFact(gfDetails, gameFact.id, match))
        }     
    }

    const getPeriodButton = usePeriodButton({match, timerValue, saveGameFact, stopPeriod, startPeriod})

    const pressTimerButton = () => {
        return
        if(match.period !== 2 && (timerValue !== 0))
            updateTimer((...params) => dispatch(updateMatch(...params, undefined, true)))
    }

    const getTimer = useButtonTimer({match, timerValue})

    const getColorButton = useCallback(() => {
        return match.statusTimer === 'on'? 'success' : 'error'
    }, [match.statusTimer])

    // GAMEFACTS TO USE COL 1 COL 2
    const gameFactToUse = gameFacts.filter(g => 
        g.discipline === match.discipline && 
        g.pos && 
        (g.id===GAME_FACT_SOCCER_BUT 
            || g.id===GAME_FACT_SOCCER_REDCARD
            || g.id===GAME_FACT_SOCCER_STAR
            || g.id===GAME_FACT_PENALITE
            || g.id===GAME_FACT_TRANSFORMATION
            || g.id===GAME_FACT_DROP
            || g.id===GAME_FACT_ESSAI
            || g.id===GAME_FACT_REDCARD
            || g.id===GAME_FACT_RUGBY_STAR
            || g.id===GAME_FACT_BASKET_FREETHROW
            || g.id===GAME_FACT_BASKET_TWOPOINTS
            || g.id===GAME_FACT_BASKET_THREEPOINTS
            || g.id===GAME_FACT_HANDBALL_GOAL
            || g.id===GAME_FACT_HANDBALL_REDCARD
            || g.id===GAME_FACT_HANDBALL_YELLOWCARD
            || g.id===GAME_FACT_HANDBALL_TWOMIN_SUSPENSION
            )
        )

        console.log('>>>>>>>>>>>>>>> gameFactToUse = ', gameFactToUse);



        const result = gameFactToUse.reduce((acc,curr) => {
            acc.push(curr)
            return acc
        }, [])

        //pos = pos:[x,y] --> x colonne (0 ou 1) - y ligne (0 à infini) /ex: (0,2 --> item 1ere colonne, ligne 3);
        result.sort((a, b) => (a.pos[0] + a.pos[1]) - (b.pos[0] + b.pos[1]) )

    const selectPlayer = (playerId, team, idxTeam) => {

        const player = team.players.find(p => p._id === playerId)

        let newPlayerSelected = [...playerSelected];
        if(player){
            newPlayerSelected[idxTeam] = player
        }else{
            newPlayerSelected[idxTeam] = {_id : 0}
        }
        setPlayerSelected(newPlayerSelected)
    }

      return (
        <Box sx={{mb : 3}} key={match.idMatch}>
          <Box sx={{background : 'white'}}>
            <Grid container >
                <Grid item xs={4.5} sx={{overflow : 'hidden'}}>
                    <Item sx={{background : match.homeTeam.color, color : match.homeTeam.textColor, display : 'flex', flexDirection : 'row', justifyContent : 'space-around'}}>
                        <Grid container sx={{alignItems : 'center'}}> 
                            
                            <Grid item xs={9}>
                                <Typography gutterBottom component="div" variant={'body2'}>{match.homeTeam.name}</Typography>
                                <Select_Dsas 
                                    items={[{_id : 0, name : 'Equipe'}, ...getPlayerList(match, match.homeTeam._id)]} 
                                    onChange={(e) => selectPlayer(e.target.value, match.homeTeam, 0)} 
                                    value={playerSelected[0]._id}
                                    onReset={() => selectPlayer(0, match.homeTeam, 0)}/>
                            </Grid>
                            <Grid item xs={3}>
                                {match.homeTeam.logoUrl && <img src={match.homeTeam.logoUrl} style={{height : '30px'}}></img>}
                            </Grid>
                        </Grid>
                    </Item>
                </Grid>
                <Grid item xs={3}>
                    <Item sx={{background : '#4973AE', color : 'white'}}><Typography gutterBottom variant="h6" component="div">{homeScore}-{awayScore}</Typography></Item>
                </Grid>
                <Grid item xs={4.5} sx={{overflow : 'hidden'}}>
                    <Item sx={{background : match.awayTeam.color, color : match.awayTeam.textColor, display : 'flex', flexDirection : 'row', justifyContent : 'space-around'}}>
                        <Grid container sx={{alignItems : 'center'}}> 
                        <Grid item xs={3}>
                                {match.awayTeam.logoUrl && <img src={match.awayTeam.logoUrl} style={{height : '30px'}}></img>}
                            </Grid>
                            <Grid item xs={9}>
                                <Typography gutterBottom  component="div" variant={'body2'}>{match.awayTeam.name}</Typography>
                                <Select_Dsas 
                                    items={[{_id : 0, name : 'Equipe'}, ...getPlayerList(match, match.awayTeam._id)]} 
                                    onChange={(e) => selectPlayer(e.target.value, match.awayTeam, 1)} 
                                    value={playerSelected[1]._id}
                                    onReset={() => selectPlayer(0, match.awayTeam, 1)}/>
                            </Grid>
                            
                        </Grid>
                    </Item>
                </Grid>
                <Grid item xs={4.5} sx={{display : 'flex', flexDirection : 'row', justifyContent : "center"}}>
                    <Grid item sm={12} md={9} sx={{paddingTop : 1}}>
                            {result.map((g, idx) => { 
                            return <GameFactIcon_Dsas src={g.img} key={idx} onClick={() => saveGameFact(g, match.homeTeam, undefined, playerSelected[0])}/>
                            })}
                    </Grid>
                </Grid>
                <Grid item xs={3} sx={{paddingTop : 1, flexDirection : 'column', justifyContent : 'flex-start', display : 'flex', alignItems : 'center'}}>
                    <Box sx={{ marginBottom : 2}}>
                    {getPeriodButton()}
                    </Box>
                    

                    <Button  variant="contained" onClick={pressTimerButton} color={getColorButton()} disabled={timerValue === 0 && match.statusTimer === 'off'} size="large" sx={{width : '60%'}}><Typography sx={{fontSize : '1em'}}>{getTimer()}</Typography></Button>
                </Grid>
                <Grid item xs={4.5} sx={{display : 'flex', flexDirection : 'row', justifyContent : "center"}}>
                    <Grid item sm={12} md={9} sx={{paddingTop : 1}}>
                    {result.map((g, idx) => {
                            return <GameFactIcon_Dsas src={g.img} key={idx} onClick={() => saveGameFact(g, match.awayTeam, undefined, playerSelected[1])}/>
                     })}
                    </Grid>
                </Grid>
            </Grid>
          </Box>
        </Box>
    
      );

}, (prevProps, nextProps) => {
    if(prevProps.match.gameFacts.length !== nextProps.match.gameFacts.length)
        return false

    return prevProps.match.gameFacts.every(prevFact => nextProps.match.gameFacts.some(nextFact => prevFact._id === nextFact._id)) &&
    prevProps.match.timer === nextProps.match.timer && 
    prevProps.match.period === nextProps.match.period && 
    prevProps.match.statusTimer === nextProps.match.statusTimer && 
    prevProps.match.status === nextProps.match.status;
});

export default LiveMultiplex